// extracted by mini-css-extract-plugin
export default {"position":"style_position__LM0dT","switch":"style_switch__jkz+Q","slider":"style_slider__L71rY","round":"style_round__DL-kt"};